import React, { useState } from 'react'
import { useMutation } from "@tanstack/react-query";
import FlipMove from "react-flip-move";
import Discipline from "../../../models/Discipline";
import ProfileItemForm from "./ProfileItemForm";
import ItemSelectModal from "../../../components/ItemSelectModal";
import TalentAverageBill from './TalentAverageBill';
import { Modal, Input, Alert } from "antd";
import Form, { FormInputComponent } from "../../../components/form/Form";
import TalentCandidate from '../../../models/TalentCandidate';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useAuth } from '../../../providers/AuthProvider';
import User from '../../../models/User';
import AIIcon from "../../../components/AiIcon";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';

export default class TalentDisciplineForm extends ProfileItemForm {

    static ItemType = 'Role'

    static FormClass = 'talent-role-form add-talent-form '

    constructor(props) {
        super(props);

        let model = this.getModelFromProps();
        let importedItem = false;
        // if (!props.user?.isApplicationApproved()) {
        importedItem = props.user.importedItemFromResume('talent_disciplines', props.model)
        // }
        this.formRef = React.createRef();

        this.state = {
            model,
            importedItem
        }
    }


    getModelFromProps() {
        let { self_score, hourly_rate, ...discipline } = TB.tryObject(this.props.model);

        let selected_skill_ids = [];
        if (!TB.keys(TB.tryObject(discipline)).length) return {};
        if (discipline?.id && this.props.skills?.length) {

            let disciplineSkills = Discipline.skillsFor(discipline?.id);
            let selectedSkills = TB.map(this.props.skills || [], 'id');
            selected_skill_ids = TB.filter(TB.map(disciplineSkills || [], 'id'), skillId => selectedSkills?.includes(skillId));
        }
        return { discipline, self_score, hourly_rate, selected_skill_ids }
    }

    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model) {

        // removing default hourly rate - jira PATDVB-9
        // if (model.discipline && !model.hourly_rate) {
        //     const platformDisciplineRate = TB.max(
        //         TB.map(model.discipline ? [model.discipline] : disciplines, dis => UserDiscipline.rateForDiscipline(dis.id)
        //         ))

        //     model.hourly_rate = platformDisciplineRate;
        // }

        if (!model.discipline?.id) {
            delete model.hourly_rate;
            delete model.self_score;
        } else if (model.discipline?.id && this.getModelFromProps().discipline?.id !== model.discipline.id) {

            let disciplineIds = TB.map((this.props.disciplines || []), 'id');

            if (this.getModelFromProps().discipline?.id) {
                disciplineIds = TB.reject(disciplineIds, this.getModelFromProps().discipline?.id);
            }

            if (disciplineIds.length && disciplineIds.includes(model.discipline.id)) {

                this.formRef.current.updateInputsWithError({
                    discipline: ''
                });

                this.formRef.current.forceValidate();
                // return this.setState({model: this.getModelFromProps()})
            }
        }

        if (model.discipline?.id && Discipline.skillsFor(model?.discipline?.id)?.length) {
            let disciplineSkills = Discipline.skillsFor(model.discipline?.id);
            let selectedSkills = TB.map(this.props.skills || [], 'id');
            model.selected_skill_ids = TB.filter(TB.map(disciplineSkills || [], 'id'), skillId => selectedSkills?.includes(skillId));

        }

        return this.setState({ model })
    }
    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     */
    async onSubmit() {
        let { self_score, hourly_rate, discipline, selected_skill_ids } = {
            ...this.getModelFromProps(),
            ...this.state.model
        };

        if (Discipline.skillsFor(discipline?.id)?.length && !selected_skill_ids?.length) {
            await TB.alert('error', 'Skills For Role Required',
                'At least one relevant skill must be added for this role. Please choose a matching skill and try again.',
                [
                    { title: 'Ok' },
                ]
            )
            return;
        }
        let confirm = true;
        if (this.props.user?.isApplicationApproved()) {
            confirm = await TB.alert('warning', 'Role requires approval',
                'A Wripple Talent Manager will need to review and approve new roles before they can be added to your profile. You can check back here to see the status of the approval. A team member may reach out via email if there are any questions. Would you like to continue?',
                [
                    { title: 'Yes, Continue' },
                    { title: 'Cancel' }
                ]
            )

            if (!confirm) {
                return;
            }
        }





        hourly_rate = Number.parseFloat(hourly_rate);

        let { name, id } = TB.tryObject(discipline);

        return super.onSubmit({
            self_score,
            hourly_rate,
            name, id
        });
    }

    getSkillsForDiscipline() {
        if (!TB.isDefined(this.state.model?.discipline?.id)) {
            return [];
        }
        return Discipline.skillsFor(this.state.model?.discipline.id);
    }


    /**
     * The fields mapping for the form
     */
    formFields = () => {
        let {
            discipline,
            self_score,
        } = this.state.model;
        let hasDisciplineSelected = TB.isDefined(discipline?.id);

        const isSupplier = this.props.user.isTalentSupplierResource();

        let positionFields = [
            {
                style: styles.fieldSection,
                fields: {
                    discipline: {
                        type: 'search',
                        searchType: 'disciplines',
                        placeholder: TB.trans('talent.talent_discipline_form.discipline_placeholder'),
                        valueLabelDisplay: 'name',
                        disabled: this.props.disabled,
                        label: `${laravel.platform_name} Role`,
                        required: true,
                        searchRequestEndpoint: '/api/talent-disciplines/search',
                        columns: 6,
                        style: styles.field,
                        validations: {
                            roleNotSelected: ({ discipline }, value) => {
                                if (!TB.isDefined(value?.id)) {
                                    return TB.trans('talent.talent_discipline_form.discipline_rule_role_not_selected')
                                }

                                return true;
                            },
                            roleAlreadySelected: ({ discipline }, value) => {

                                let disciplineIds = TB.map((this.props.disciplines || []), 'id');

                                if (this.getModelFromProps().discipline?.id) {
                                    disciplineIds = TB.filter(disciplineIds, id => id !== this.getModelFromProps().discipline?.id);
                                }
                                if (TB.isDefined(value?.id) && disciplineIds.length && disciplineIds.includes(value.id)) {
                                    return "Role already selected";
                                }

                                return true;
                            }
                        },
                        appendAfter: !hasDisciplineSelected && (
                            <p className="btn-form-modal" onClick={() => this.showModal()}>
                                {TB.trans('talent.talent_discipline_form.view_role_descriptions')}
                            </p>
                        )
                    },
                    self_score: {
                        type: 'select',
                        label: TB.trans('talent.talent_discipline_form.self_score_label'),
                        required: true,
                        disabled: this.props.disabled,
                        hideVisibility: !hasDisciplineSelected,
                        options: laravel.talent_scoring_options,
                        placeholder: TB.trans('talent.talent_discipline_form.self_score_placeholder'),
                        style: styles.field,
                        columns: 3,
                    },

                }
            }
        ];

        if (!isSupplier || this.props.isAdminEditing) {
            positionFields[0].fields.hourly_rate = {
                label: TB.trans('talent.talent_discipline_form.hourly_rate_label'),
                type: 'number',
                addonBefore: "$",
                placeholder: TB.trans('talent.talent_discipline_form.hourly_rate_placeholder'),
                required: true,
                disabled: this.props.disabled,
                hideVisibility: !hasDisciplineSelected,
                validationErrors: {
                    isDefaultRequiredValue: TB.trans('talent.talent_discipline_form.hourly_rate_validation_errors.missing_hourly_rate'),
                },
                style: styles.field,
                columns: 3
            }
        }
        // hourly_rate: {
        //     label: TB.trans('talent.talent_discipline_form.hourly_rate_label'),
        //     type: 'number',
        //     addonBefore: "$",
        //     placeholder: TB.trans('talent.talent_discipline_form.hourly_rate_placeholder'),
        //     required: true,
        //     disabled: this.props.disabled,
        //     hideVisibility: !hasDisciplineSelected,
        //     validationErrors: {
        //         isDefaultRequiredValue: TB.trans('talent.talent_discipline_form.hourly_rate_validation_errors.missing_hourly_rate'),
        //     },
        //     style: styles.field,
        //     columns: 3
        // },


        if (this.props.isEditing) {

            let disciplineSkills = this.getSkillsForDiscipline()
            let skills = disciplineSkills;

            if (hasDisciplineSelected) {

                let userSkills = TB.keyBy(this.props.user.skills, 'id');

                skills = TB.map(skills, (skill) => {
                    return userSkills[skill.id] || skill
                });
            }


            positionFields.push(
                {
                    style: styles.fieldSection,
                    fields: {
                        skills: {
                            component: (discipline?.name && skills.length > 0) ? (
                                <>
                                    {(!isSupplier || this.props.isAdminEditing) && <TalentAverageBill discipline={discipline} highlighted={false} />}
                                    <div className={"form-group mt-3"} style={styles.field}>
                                        <div className="form-title-section">
                                            <div className="step-title-content p-0">
                                                <div>
                                                    <h5 className="form-subtitle mb-3">
                                                        <span>
                                                            Choose a least one skill and rate your experience or expertise level for your role:
                                                            <span className="text-primary ml-2">
                                                                {discipline.name}
                                                            </span>
                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={"discipline-skills-container mt-1 gap-3"}>
                                            <FlipMove typeName={null}>
                                                {TB.orderBy(skills, [({ self_score }) => !TB.isNil(self_score), 'pivot.display_index'], ['desc', 'asc'])
                                                    .map((skill, index) => (
                                                        <div key={`discipline-${discipline.id}-skill-${skill.id}`}>
                                                            <NEWSkillFormButton
                                                                disabled={this.props.disabled}
                                                                skill={skill}
                                                                className={skill.category && "min-w-[165px]"}
                                                                scoringOptions={skill.category ? laravel.talent_scoring_options_by_category[skill.category] : laravel.talent_scoring_options}
                                                                type={skill.category ? 'info' : 'default'}
                                                                onChange={(skill) => this.selectSkill(skill)}
                                                            />
                                                        </div>
                                                    ))}
                                            </FlipMove>
                                        </div>
                                        <div className="form-title-section">
                                            <div className="step-title-content p-0">
                                                <div>
                                                    <h5 className="form-subtitle mt-3">
                                                        <span>
                                                            Don't see a skill you are looking for? You can add more skills later.
                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                disciplineSkills?.length > 0 ? (
                                    <div className={"form-group mt-3"} style={styles.field}>
                                        <div className={"help-element mt-2"}>
                                            <p>{TB.trans('talent.talent_discipline_form.skills_placeholder')}</p>
                                        </div>
                                    </div>
                                ) : <div />
                            ),
                        },
                    }
                },

            );
        }
        return positionFields
    };

    showModal() {
        return TB.event("Modal@show", {
            title: 'Browse categories and select a role you want to play',
            content: (
                <ItemSelectModal
                    fieldName="disciplines"
                    selectText="Select Role"
                    onSelectItem={async (discipline) => {
                        await this.formRef.current.updateInputsWithValue({
                            discipline
                        })
                        await TB.event("Modal@hide", true);
                    }}
                    selectedIds={TB.map(this.props.user.talent_disciplines || [], 'id')}
                    multiSelect={false}
                    isDisabled={false}
                    categoryHeader="Role Category"
                    hideModal={() => TB.event("Modal@hide", true)}
                    itemHeader={`${laravel.platform_name} Role`}
                    items={[...laravel.discipline_categories]}
                />
            )
        })
    }

    /***********************************
     * Update Project Position
     ************************************/
    async selectSkill(model) {

        let user = TB.pick({ ...this.props.user }, ['skills']);
        if (!user.skills) {
            user.skills = [];
        }
        let skillIndex = TB.findIndex(user.skills, ['id', model.id]);

        if (skillIndex !== -1) {
            if (!TB.isNil(model.self_score)) {
                user = TB.set(user, `skills[${skillIndex}]`, model);
            } else {
                TB.unset(user, `skills[${skillIndex}]`);
                // console.log('unset')
            }
        } else {
            user.skills.push({ ...model })
        }

        user.skills = TB.filter(user.skills, s => !TB.isNil(s?.id))

        await this.props.onChange(user);
        if (this.state.model?.discipline?.id && Discipline.skillsFor(this.state.model?.discipline?.id)?.length) {
            let disciplineSkills = Discipline.skillsFor(this.state.model?.discipline?.id);
            let selectedSkills = TB.map(user.skills || [], 'id');
            this.setState({
                model: {
                    ...this.state.model,
                    selected_skill_ids: TB.filter(
                        TB.map(disciplineSkills || [], 'id'),
                        skillId => selectedSkills?.includes(skillId)
                    )
                }
            })
        }
    }

    renderTitle() {
        let name = this.state.model?.discipline?.name;

        const { discipline } = this.state.model;

        let disc = discipline;

        if (discipline?.latest_appeal) {
            disc = { ...discipline.latest_appeal, discipline_id: discipline.id };
        }

        let status;
        if (!disc?.is_approved && !disc?.is_rejected) { // pending
            status = {
                className: 'bg-yellow-100 text-yellow-800',
                title: 'Pending Approval',
            }
        } else if (disc?.is_rejected) {
            status = {
                className: 'bg-red-100 text-red-800',
                title: 'Not Approved',
            }
        } else if (disc?.is_approved) {
            status = {
                className: 'bg-green-100 text-green-800',
                title: 'Approved',
            }
        }

        return (
            <div className="form-title-section">
                <div className="step-title-content w-full">
                    <div>
                        <h3 className="form-title">
                            {name ? (
                                <span>
                                    Select skills and experience level for:
                                    <span className="text-primary">
                                        {' ' + this.state.model?.discipline?.name}
                                    </span>
                                </span>
                            ) : 'Select or search for role'}
                        </h3>
                    </div>
                    <div className="flex-none text-right flex flex-col items-end">
                        {(!this.props.user?.isTalentSupplierResource() && this.props.user?.isApplicationApproved()) ? (
                            <React.Fragment>
                                {discipline && (
                                    <div className="flex gap-2">
                                        {disc?.is_rejected && (
                                            <AppealModal
                                                discipline={disc}
                                                disciplineName={discipline.name}
                                                isAppeal={!!discipline?.latest_appeal}
                                                onChange={(updates) => this.setState({ model: { ...this.state.model, ...updates } })}
                                            />
                                        )}

                                        <p className={`inline-block text-xs font-medium px-2.5 py-0.5 rounded ${status.className}`}>{status.title}</p>
                                    </div>
                                )}

                                {(!disc?.is_approved && !disc?.is_rejected) && discipline?.latest_appeal && (
                                    <p className="text-xxs text-gray-500 py-2">Appeal submitted: {TB.moment(disc?.created_at).format('ll')}</p>
                                )}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                {!!this.state.importedItem && (
                                    <div className="flex gap-2">
                                        <p className={`flex flex-row items-center gap-0.5 text-xs font-medium pr-1 pl-2 py-0.5 rounded bg-purple-100 text-purple-800`}>

                                            Imported From Resume
                                            <AIIcon />
                                        </p>
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        )
    }


    /**
     * Show info on bottom of panel
     *
     * @returns {div}
     */
    renderFormFooterInfo() {
        let { discipline } = this.state.model;

        if (!this.getSkillsForDiscipline()?.length) {
            return null;
        }
        let selectedSkills = this.props.user?.selectedSkillsForDiscipline(discipline?.id) || [];

        return (
            <div className="flex flex-row items-center order-1 px-6">
                {selectedSkills?.length === 0 ? (
                    <p className="text-danger text-xs">
                        <b>0</b> skills selected. Please edit the role and add at least one skill to continue.
                    </p>
                ) : (
                    <p className="text-xs text-primary">
                        <b>{selectedSkills?.length}</b> {TB.pluralize('skill', selectedSkills?.length || 0)} selected. Edit the role to view or add more.
                    </p>
                )}
            </div>
        )
    }

    /**
     * Edit button for form
     *
     * @returns {div}
     */
    renderEditFormButton() {
        return (
            <button
                className="btn btn-primary px-6"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}>
                Edit Role/Skills
            </button>
        );
    }

}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};


const AppealModal = ({ discipline, disciplineName, isAppeal, onChange }) => {
    const { auth, update: updateAuth } = useAuth();
    const [isAppealModalOpen, setIsAppealModalOpen] = useState(false);
    const [showAppealForm, setShowAppealForm] = useState(false);

    const handleClose = () => {
        setIsAppealModalOpen(false);
        setShowAppealForm(false);
    }

    const addTalentRoleAppealMutation = useMutation(['applicationRoleAppeal'],
        params => TalentCandidate.addTalentRoleAppeal((discipline.discipline_id || discipline.id), params),
        {
            onSuccess: async data => {
                handleClose();

                const talent_disciplines = auth.talent_disciplines.map(dis => {
                    if (dis.id === (discipline.discipline_id || discipline.id)) {
                        return {
                            ...dis,
                            latest_appeal: data.appeal,
                        }
                    }
                    return dis
                });

                const updatedUser = User.make({ ...auth, talent_disciplines });
                const didUpdate = await updateAuth(updatedUser);

                if (didUpdate) {
                    let updatedDiscipline = TB.find(talent_disciplines, ['id', (discipline.discipline_id || discipline.id)]);
                    onChange({ discipline: updatedDiscipline });

                    TB.alert('success', 'Role Appeal Submitted', 'A talent manager will review your appeal and will reach out via email.')
                }
            },
            onError: err => {
                console.log(err, 'ERRRORR')
            }
        }
    )


    return (
        <>
            <button
                type="button"
                className="btn p-0 min-w-[unset] py-0"
                onClick={() => setIsAppealModalOpen(true)}
            >
                <i className="fa fa-info-circle text-black text-sm" />
            </button>
            <Modal
                title={`${isAppeal ? 'Appeal' : 'Role'} Not Approved for ${disciplineName}`}
                closable={true}
                maskClosable={true}
                style={{ top: 150 }}
                destroyOnClose={true}
                width={500}
                footer={null}
                open={isAppealModalOpen}
                onCancel={handleClose}
                onClose={handleClose}
            >
                {addTalentRoleAppealMutation.isLoading && (
                    <div className="absolute top-0 left-0 h-full w-full flex items-center justify-center z-10">
                        <LoadingSpinner size="lg" />
                    </div>
                )}
                {showAppealForm ? (
                    <Form
                        showRequired
                        background={'transparent'}
                        title={null}
                        subtitle={null}
                        submitButton={false}
                        className="[&>.form-container]:p-0"
                        style={{ padding: 20 }}
                        onSubmit={async fields => addTalentRoleAppealMutation.mutateAsync(fields)}
                        isDisabled={addTalentRoleAppealMutation.isLoading}
                        fields={[]}
                    >
                        <div>
                            <label htmlFor="appeal-reason" className="block pb-1">
                                Write a note to explain your reason for appeal. After your appeal is submitted, a Wripple Talent Manager will review and reach out via email if there are any questions.
                            </label>

                            <FormInputComponent
                                fieldName="notes"
                                disabled={addTalentRoleAppealMutation.isLoading}
                                required
                                label="Notes"
                                type="antd-input"
                            >
                                <Input.TextArea
                                    showCount
                                    bordered
                                    id="appeal-reason"
                                    autoSize={{ minRows: 4 }}
                                    maxLength={500}
                                />
                            </FormInputComponent>
                        </div>
                        <div className="flex flex-row justify-between items-center gap-3">
                            <div className="mr-auto">
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={() => setShowAppealForm(false)}
                                >
                                    Back
                                </button>

                                {addTalentRoleAppealMutation.failureReason && (
                                    <p className="text-danger mr-auto">{addTalentRoleAppealMutation.failureReason?.message}</p>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn btn-outline-dark"
                                disabled={addTalentRoleAppealMutation.isLoading}
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={addTalentRoleAppealMutation.isLoading}
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                ) : (
                    <>
                        <div>
                            <p>
                                This {isAppeal ? 'appeal' : 'role'} is not approved at this time.
                                Further feedback from the Wripple Talent Team has been provided below.
                                {!isAppeal ? ' If you believe this decision is incorrect, you may request an appeal at any time using the button below.' : ''}
                            </p>

                            <Alert
                                className="mt-4"
                                description={(
                                    <p>
                                        Feedback: {discipline.rejection_notes}
                                    </p>
                                )}
                                type="warning"
                            />
                        </div>
                        <div className="pt-5 flex flex-row justify-between gap-3">
                            <button
                                type="button"
                                className="btn btn-link"
                                onClick={() => {
                                    if (discipline.can_submit_appeal) {
                                        setShowAppealForm(true)
                                    } else {
                                        handleClose();
                                        TB.alert('warning', "Can't resubmit appeal at this time", 'Your last appeal was not approved. You can resubmit an appeal 1 year from the date it was not approved if you still disagree with this decision.')
                                    }
                                }}
                            >
                                Submit Appeal
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleClose}
                            >
                                Close
                            </button>
                        </div>
                    </>
                )}
            </Modal>
        </>
    )
}